export const isEnabledFromFeatureFlag = ({ flagKey, flagName, flagValue, variants, }) => {
    const { key: contextFlagKey, value: contextFlagValue } = variants?.[flagName] || {};
    return contextFlagKey === flagKey && contextFlagValue === flagValue;
};
